import { applyIfFunction } from './callIfFunction';
import { getProperty } from './getProperty';

export const getApiErrorMessage = (error: any, defaultMessage = 'Unknown error'): string => {
  if (!error) {
    return defaultMessage;
  }
  if (error?.status === 504) {
    return 'Service not available';
  }
  if (error?.status === 500) {
    return 'Internal error occurred, please try later again!';
  }
  let payload = getProperty(error, 'response.data');
  if (!payload) {
    payload = applyIfFunction(error, error.toJSON);
  }
  let message = getProperty(payload, 'message');
  if (!message) {
    message = getProperty(error, 'message');
  }
  return message || defaultMessage;
};
